import React, { useEffect, useState } from "react";
import "./UserManagement.css";
import OverviewCard from "../../components/OverView-Card/overview-card";
import RegistrationTable from "../../components/Registration-table/registration-table";
import PopularBond from "../../components/Popular-bond/Popular-bond";
import RegistartionDetail from "../../components/Registration-details/Registartion-detail";
import RegistartionTableWealth from "../../components/Registration-table-wealth";
import { useNavigate, useNavigation } from "react-router-dom";
import SelectButton from "../../components/SelectButton";
import download from "../../assets/clarity_download-line.png";
import { createColumnHelper } from "@tanstack/react-table";
import moment from "moment";
import ReactTable from "../../components/ReactTable";
import eye from "../../assets/eye.png";
import editBond from "../../assets/editBond.png";
import delBond from "../../assets/deleteBond.png";
import sendLinkImage from "../../assets/send.svg";
import CustomPagination from "../../components/CustomPagination";
import axios from "axios";
import ToggleButton from "./Toggle";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import DeleteConfirmationModal from "../../components/DeleteConfirmationModal";
export const base_url = process.env.REACT_APP_BASE_URL;
export const api_type = process.env.REACT_APP_API_TYPE;

const toastIds = {
  statusSuccess: "status-success-toast",
  statusError: "status-error-toast",
  sendLinkSuccess: "send-link-success-toast",
  sendLinkError: "send-link-error-toast",
};

function UserCreation() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("User Creation");
  const [selectedOccupation, setSelectedOccupation] = useState("");
  const [selectedReferal, setSelectedReferal] = useState(null);
  const [selectNumber, setSelectedNumber] = useState(null);
  const [searchInput, setSearchInput] = useState("");
  const [searchInputApi, setSearchInputApi] = useState("");
  const [investorDetails, setInvestorDetails] = useState([]);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [userToDelete, setUserToDelete] = useState(null);
  // const [page, setPage] = useState(1);
  const [page, setPage] = useState(() => {
    const savedPage = localStorage.getItem('userCreationPage');
    return savedPage ? Number(savedPage) : 1;
  });
  const [total, setTotal] = useState(0);
  const [pageSize, setPazeSize] = useState(0);
  const [rolesData, setRolesData] = useState();

  const { userPermissionData } = useSelector((state) => state.userPermission);

  const [error, setError] = useState(null);

  console.log("rolesData", rolesData);

  const optionsOccupation = [
    "All",
    "Pending",
    "Under Review",
    "Approve",
    "Query Raised",
    "Update Request",
  ];

  const optionsRefered = ["All"];

  const optionsShow = ["All", "10", "20", "50"];
  const buttonData = [
    {
      label: "Role Creation",
      path: "/user", // Path for the Investor button
    },
    {
      label: "User Creation",
      path: "/user/creation", // Path for the Wealth Partner button
    },
  ];
  const investorsData = [
    {
      investorName: "CHETAN DILIP GHARMALKAR",
      uccCode: "---",
      kycStatus: "Pending",
      registrationDate: "06-11-2024",
      referredBy: "John Doe",
      action: "view",
    },
    {
      investorName: "KARVY CAPITAL ARBITRAGE OPPORTUNITIES FUND",
      uccCode: "IN0011",
      kycStatus: "Under Review",
      registrationDate: "05-11-2024",
      referredBy: "--",
      action: "view",
    },
    {
      investorName: "HCC SAMSUNG JOINT VENTURE",
      uccCode: "IN0010",
      kycStatus: "Approve",
      registrationDate: "05-11-2024",
      referredBy: "John Doe",
      action: "view",
    },
    {
      investorName: "GLOBAL INVESTMENTS LTD",
      uccCode: "---",
      kycStatus: "Pending",
      registrationDate: "04-11-2024",
      referredBy: "--",
      action: "view",
    },
    {
      investorName: "SUNNYVALE TECH SOLUTIONS",
      uccCode: "IN0012",
      kycStatus: "Under Review",
      registrationDate: "04-11-2024",
      referredBy: "John Doe",
      action: "view",
    },
    {
      investorName: "GREEN ENERGY INNOVATIONS",
      uccCode: "IN0007",
      kycStatus: "Approve",
      registrationDate: "04-11-2024",
      referredBy: "--",
      action: "view",
    },
    {
      investorName: "BLUE OCEAN STRATEGIES",
      uccCode: "IN0013",
      kycStatus: "Under Review",
      registrationDate: "03-11-2024",
      referredBy: "John Doe",
      action: "view",
    },
    {
      investorName: "BLUE OCEAN STRATEGIES",
      uccCode: "IN0005",
      kycStatus: "Approve",
      registrationDate: "03-11-2024",
      referredBy: "John Doe",
      action: "view",
    },
  ];

  const toggleStatus = async (id) => {
    console.log("did", id);

    // return;
    const endpoint = `${base_url}/${api_type}/userManagement/${id}/toggle`;

    try {
      const response = await axios.put(
        endpoint,
        {},
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`, // Replace 'your-auth-token' with the actual token
          },
        }
      );

      if (!toast.isActive(toastIds.statusSuccess)) {
        toast.success("Status Updated", {
          toastId: toastIds.statusSuccess,
          autoClose: 3000,
        });
      }
      fetchInvestorDetails();
    } catch (err) {
      if (!toast.isActive(toastIds.statusError)) {
        toast.error(err?.response?.data.message || "Failed to update status", {
          toastId: toastIds.statusError,
          autoClose: 3000,
        });
      }
      console.error("Failed to update status:", err);
      setError(err.message);
    }
  };
  const getRoles = async () => {
    const endpoint = `${base_url}/${api_type}/roles`;

    try {
      const response = await axios.get(endpoint, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`, // Replace 'your-auth-token' with the actual token
        },

        params: {
          page: page,
          search: searchInputApi,
        },
      });
      console.log("role response", response);
      if (response?.data?.data?.roles) {
        // Filter unique roles based on 'roleName'
        const uniqueRoles = Array.from(
          new Map(
            response.data.data.roles.map((role) => [role.name, role])
          ).values()
        );
        const roleNames = uniqueRoles.map((role) => role.name);
        console.log("uniqueRoles", uniqueRoles);
        roleNames.unshift("All");
        setRolesData(roleNames); // Set unique roles data
      }

      // setPage(response?.data?.data?.pagination?.currentPage);
      // setTotal(response?.data?.data?.pagination?.totalRecords);
      // setPazeSize(response?.data?.data?.pagination?.perPage); // Adjust according to your API response structure
    } catch (err) {
      console.error("Failed to fetch pending orders:", err);
      setError(err.message);
    }
  };

  const columnHelper = createColumnHelper();

  const handleClick = (path, label) => {
    setActiveTab(label);
    navigate(path); // Navigate to the given path
  };

  const handleSelectOccupation = (value) => {
    setSelectedOccupation(value);
  };

  const handleSelectReferal = (value) => {
    setSelectedReferal(value);
  };

  const handleSelectNumber = (value) => {
    setSelectedNumber(value);
  };

  const fetchInvestorDetails = async () => {
    const endpoint = `${base_url}/${api_type}/userManagement`;

    try {
      const response = await axios.get(endpoint, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`, // Replace 'your-auth-token' with the actual token
        },

        params: {
          page: page,
          search: searchInputApi,
          // userType: "partner",
          status: selectedOccupation,
        },
      });
      console.log("user creation lits", response);
      setInvestorDetails(response?.data?.data?.list);
      setPage(response?.data?.data?.currentPage);
      // setTotal(response?.data?.data?.totalPages);
      // setPazeSize(response?.data?.data?.totalPages); // Adjust according to your API response structure
      setTotal(response?.data?.data?.totalRecords);
      setPazeSize(response?.data?.data?.perPage || 10); // Set default page size if not provided
    } catch (err) {
      console.error("Failed to fetch pending orders:", err);
      setError(err.message);
    }
  };
  useEffect(() => {
    fetchInvestorDetails();
    getRoles();
  }, [page, selectedOccupation, searchInputApi]);

  // Add useEffect to handle automatic search when input is cleared
  useEffect(() => {
    if (searchInput === '') {
      setSearchInputApi('');
    }
  }, [searchInput]);

  const handleSendLink = async (id) => {
    const endpoint = `${base_url}/${api_type}/userManagement/${id}/sendLink`;

    try {
      const response = await axios.put(
        endpoint,
        {},
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`, // Replace 'your-auth-token' with the actual token
          },
        }
      );

      if (!toast.isActive(toastIds.sendLinkSuccess)) {
        toast.success("An activation link has been sent to the registered email ID" || response?.data?.message || "Link sent successfully", {
          toastId: toastIds.sendLinkSuccess,
          autoClose: 3000,
        });
      }
    } catch (err) {
      if (!toast.isActive(toastIds.sendLinkError)) {
        toast.error(err?.response?.data?.message || "Failed to send link", {
          toastId: toastIds.sendLinkError,
          autoClose: 3000,
        });
      }
      console.error("Failed to send link:", err);
      setError(err.message);
    }
  };

  const handleDeleteUser = async (id) => {
    const endpoint = `${base_url}/${api_type}/userManagement/${id}`;

    try {
      const response = await axios.delete(endpoint, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`, // Replace 'your-auth-token' with the actual token
        },
      });

      console.log("delete user response", response);
      toast.success("User deleted successfully");
      fetchInvestorDetails();
    } catch (err) {
      toast.error("Failed to delete user");
      console.error("delete user:", err);
      setError(err.message);
    }
  };

  const openDeleteModal = (id) => {
    setUserToDelete(id);
    setIsDeleteModalOpen(true);
  };

  const closeDeleteModal = () => {
    setIsDeleteModalOpen(false);
    setUserToDelete(null);
  };

  const confirmDelete = () => {
    if (userToDelete) {
      handleDeleteUser(userToDelete);
      closeDeleteModal();
    }
  };

  const columns = [
    columnHelper.display({
      id: "sn", // A unique ID for the column
      cell: (info) => {
        const status = info?.row?.original?.status;
        const serialNumber = (page - 1) * 10 + info.row.index + 1;
        return (
          <div className="w-[27px] h-[27px] py-1 flex justify-center items-center rounded text-center text-sm">
            {serialNumber}
          </div>
        );
      },
      header: () => <span>Sr. No.</span>,
    }),
    columnHelper.accessor("name", {
      cell: (info) => info.renderValue(),
      header: () => <span>Username</span>,
    }),

    columnHelper.accessor("role.name", {
      cell: (info) => (info.renderValue() ? `${info.renderValue()}` : "N/A"),
      header: () => (
        <div className=" ">
          <span>Role </span>
        </div>
      ),
    }),
    columnHelper.accessor("isActive", {
      // cell: (info) => (info.renderValue() ? info.renderValue() : "N/A"),
      cell: (info) => {
        const value = info?.row;
        const roleId = info?.row?.original?.id;
        const roleType = info?.row?.original?.name;
        return (
          <div
            className={` w-[50px] h-[27px] py-1 flex justify-center items-center rounded text-center text-sm`}
          >
            <div
              onClick={() =>
                value?.original?.role?.name !== "admin"
                  ? toggleStatus(value?.original?.id)
                  : () => {}
              }
              className={`relative inline-flex items-center ${
                value?.original?.role?.name !== "admin" && `cursor-pointer`
              }  w-[50px] h-6 rounded-full transition-colors ${
                value?.original?.isActive ? "bg-green-500" : "bg-gray-300"
              }`}
            >
              {/* Toggle Circle */}
              <div
                className={`absolute w-5 h-5 bg-white rounded-full shadow-md transform transition-transform ${
                  value?.original?.isActive ? "translate-x-6" : "translate-x-1"
                }`}
              ></div>
            </div>
          </div>
        );
      },
      header: () => <span>Active</span>,
    }),
    // columnHelper.accessor("name", {
    //   cell: (info) => (info.renderValue() ? `${info.renderValue()}` : "N/A"),
    //   header: () => (
    //     <div className=" ">
    //       <span>Send Link </span>
    //     </div>
    //   ),
    // }),
    columnHelper.accessor((row) => row, {
      id: "Send Link",
      cell: (info) => {
        const uniqueId = info?.row?.original?.id;

        const deleteBond = (id) => {
          // deleteBondsId(id);
        };
        return (
          <div className="flex justify-start ">
            <img
              onClick={() => handleSendLink(uniqueId)}
              src={sendLinkImage}
              alt="send link"
              className="cursor-pointer pr-8"
            />
          </div>
        );
      },
      header: () => <span>Send Link</span>,
    }),
    columnHelper.accessor((row) => row, {
      id: "action",
      cell: (info) => {
        const uniqueId = info?.row?.original?.id;
        console.log("investorid", uniqueId);
        const NavigateScheme = (uniqueId) => {
          navigate(`/user/edit-user/${uniqueId}`, {
            state: {
              uniqueId: uniqueId,
            },
          });
        };
        const deleteBond = (id) => {
          openDeleteModal(id);
        };
        return (
          <div className="flex justify-start ">
            {userPermissionData?.user?.edit && (
              <img
                onClick={() => NavigateScheme(uniqueId)}
                src={editBond}
                alt="Eye "
                className="cursor-pointer pr-8"
              />
            )}
            {userPermissionData?.user?.delete && (
              <img
                onClick={() => deleteBond(uniqueId)}
                src={delBond}
                alt="Eye "
                className="cursor-pointer"
              />
            )}
          </div>
        );
      },
      header: () => <span>Action</span>,
    }),
  ];
  const handleSearchInput = (value) => {
    setSearchInput(value);
  };
  const handleSearchClick = () => {
    setPage(1);
    setSearchInputApi(searchInput);
  };

  return (
    <div className="mt-[60px] px-4 flex flex-col min-h-[calc(100vh-60px)]">
      <DeleteConfirmationModal
        isOpen={isDeleteModalOpen}
        onClose={closeDeleteModal}
        onConfirm={confirmDelete}
        message="Are you sure you want to delete this user? This action cannot be undone."
      />
      <div className="flex flex-wrap justify-center md:justify-start">
        {buttonData.map((button, index) => (
          <button
            key={index}
            className={`w-[135px] text-[14px] px-4 py-2   ${
              activeTab === button.label ? "bg-[#035C98] text-white " : ""
            } ${
              index === 0 ? "rounded-l" : "rounded-r"
            } focus:outline-none focus:ring-2`}
            onClick={() => handleClick(button.path, button.label)} // Navigate on click
          >
            {button.label}
          </button>
        ))}
      </div>
      <div className="bg-white px-8 py-2 mt-4 rounded-[10px] overflow-auto">
        <h1 className="text-[#252C32] text-[24px]">User Creation </h1>
        <div class="">
          <div class="flex flex-wrap justify-between  items-center gap-x-2 py-4 gap-y-4">
            <div className="flex flex-wrap gap-2">
              <div class="flex gap-0.5">
                <input
                  type="text"
                  placeholder="Search by UserName"
                  className="rounded-l-[8px] w-[217px]"
                  value={searchInput}
                  onChange={(e) => handleSearchInput(e?.target?.value)}
                />
                <button
                  onClick={handleSearchClick}
                  className=" bg-[#035C98] text-white font-bold py-2 px-4 rounded-r-[8px]"
                >
                  Search
                </button>
              </div>
              <div class="flex items-center">
                <div className="flex items-center  absolute">
                  <SelectButton
                    options={rolesData}
                    selectedValue={selectedOccupation}
                    onSelect={handleSelectOccupation}
                  />
                </div>
              </div>
            </div>
            {userPermissionData?.user?.create && (
              <div class="flex items-center bg-[#035C98] px-4 rounded-[8px]">
                <a
                  href="/user/new-user"
                  class="btn text-white font-bold cursor-pointer"
                >
                  Add User
                </a>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="w-full font-poppins mt-3 pt-4 bg-white rounded-[10px]">
        <ReactTable
          key={JSON?.stringify(investorDetails)}
          defaultData={investorDetails}
          columns={columns}
        />
      </div>

      {investorDetails?.length > 0 && (
        <div className="w-auto mt-auto border-t">
          <CustomPagination
            currentPage={page}
            setCurrentPage={setPage}
            totalItems={total}
            itemsPerPage={pageSize || 10}
            maxPageNumbersToShow={5}
            storageKey="userCreationPage"
          />
        </div>
      )}
    </div>
  );
}

export default UserCreation;
